/* import __COLOCATED_TEMPLATE__ from './fly-power-select-multiple.hbs.js'; */
var _dec, _dec2, _dec3, _dec4, _class;
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import Component from '@glimmer/component';
import EmObject, { get, getProperties, action } from '@ember/object';
import { computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import itemProperty from '@customerio/fly-components/utils/item-property';
import { A } from '@ember/array';
import { filterOptions } from 'ember-power-select/utils/group-utils';
import { ensureSafeComponent } from '@embroider/util';
import { isPowerSelectGroup, flattenOptions } from '@customerio/fly-components/utils/power-select';
import { stringIncludes } from '@customerio/fly-components/utils/string';
import { typeOf } from '@ember/utils';
import PowerSelectBeforeOptions from 'ember-power-select/components/power-select/before-options';
import FlyPowerSelectMultipleToggle from '@customerio/fly-components/components/fly-power-select-multiple/toggle';
import FlyPowerSelectList from '@customerio/fly-components/components/fly-power-select/list';
/**
  @public
  @class FlyPowerSelectMultiple
 **/
let FlyPowerSelectMultiple = (_dec = computed('args.options.[]'), _dec2 = computed('labelProperty', 'searchField', 'optionsEmArray.[]'), _dec3 = computed('args.options.[]', 'args.selectedItems', 'args.selectedValues.[]', 'valueProperty'), _dec4 = computed('itemSeparator', 'labelProperty', 'valueProperty', 'size', 'matchContentWidth', 'args.{iconProperty,iconFillProperty,secondaryLabelProperty,onScrollEnd,itemWidth}'), (_class = class FlyPowerSelectMultiple extends Component {
  get beforeOptionsComponent() {
    if (this.args.beforeOptionsComponent != null) {
      return this.args.beforeOptionsComponent;
    } else if (this.args.searchInsideToggle) {
      return null;
    }
    return PowerSelectBeforeOptions;
  }
  get itemSeparator() {
    return this.args.itemSeparator ?? 'or';
  }
  get labelProperty() {
    return this.args.labelProperty ?? 'label';
  }
  get valueProperty() {
    return this.args.valueProperty ?? 'value';
  }
  get matchContentWidth() {
    return this.args.matchContentWidth ?? true;
  }
  get size() {
    return this.args.size ?? 'normal';
  }
  get noMatchesMessage() {
    return this.args.noMatchesMessage ?? "Oops! There's nothing to choose from…";
  }
  get placeholder() {
    return this.args.placeholder ?? 'Search…';
  }
  get renderInPlace() {
    return this.args.renderInPlace ?? true;
  }
  get matcher() {
    return this.args.matcher ?? null;
  }
  get searchField() {
    // If there's no searchField provided, it makes sense to search for what's
    // shown, i.e. the label property.
    return this.args.searchField ?? this.labelProperty;
  }
  get verticalPosition() {
    return this.args.verticalPosition ?? 'below';
  }
  get horizontalPosition() {
    return this.args.horizontalPosition ?? 'auto';
  }
  get optionsComponent() {
    return ensureSafeComponent(this.args.optionsComponent ?? FlyPowerSelectList, this);
  }
  get triggerComponent() {
    return ensureSafeComponent(this.args.triggerComponent ?? FlyPowerSelectMultipleToggle, this);
  }
  get showTrailingEllipsis() {
    return this.args.showTrailingEllipsis ?? true;
  }

  /**
    An EmberArray instance of the options array. Needed to support usage with DS.PromiseArray.
     @property optionsEmArray
    @type EmberArray
    @private
   */
  get optionsEmArray() {
    return A(this.args.options);
  }

  // search field can only be set when the items are objects
  get _computedsearchProperty() {
    if (isEmpty(this.optionsEmArray) || !this.optionsEmArray.slice().some(option => typeof option === 'object')) {
      return;
    }
    return this.searchField || this.labelProperty;
  }
  get selectedItems() {
    if (this.args.selectedItems) {
      return this.args.selectedItems;
    }
    let {
      args: {
        selectedValues
      },
      optionsEmArray,
      valueProperty
    } = this;
    if (isEmpty(optionsEmArray)) {
      return A([]);
    }
    if (optionsEmArray.slice().some(opt => isPowerSelectGroup(opt))) {
      optionsEmArray = A(flattenOptions(optionsEmArray));
    }
    return optionsEmArray.filter(option => selectedValues.includes(itemProperty(option, valueProperty)));
  }

  // This property can be passed to the power-select component. It is then shared with all child components that are rendered.
  // https://ember-power-select.com/docs/api-reference
  get _extra() {
    let extraPropertiesArgs = ['iconProperty', 'iconFillProperty', 'onScrollEnd', 'secondaryLabelProperty', 'itemWidth', 'matchContentWidth'];
    let extraPropertiesThis = ['itemSeparator', 'labelProperty', 'valueProperty', 'size', 'matchContentWidth'];

    // During the emit phase of typescript, it will complain that `this` is not
    // accessible in this context, and requires a custom type. Further, typing
    // `this` in the getter declaration is also not allowed by the TS compiler.
    // This line is a hack to get around the restrictions during the emit phase.
    /* eslint-disable-next-line @typescript-eslint/no-this-alias */
    let anyThis = this;
    return EmObject.create({
      multiSelect: true,
      ...getProperties(anyThis.args, ...extraPropertiesArgs),
      ...getProperties(anyThis, ...extraPropertiesThis),
      ...(anyThis.args.extra || {})
    });
  }
  onSelectAction(items, select) {
    // items sometimes isn't an array, due to a PowerSelect bug:
    // https://github.com/cibernox/ember-power-select/issues/1522
    if (typeOf(items) !== 'array') {
      items = [items];
    }

    // We should clear search on select, otherwise the last search term and the
    // results stick around.
    select.actions.search('');
    this.args.onChange(items, select);
  }
  async _searchWithCreate(term, select) {
    // await to support DS.PromiseArray:
    let options = await this.optionsEmArray;
    if (term.length === 0) {
      return options;
    }
    if (this.args.search) {
      let results = await this.args.search(term, select);
      return this._getModifiedResults(term, results);
    }
    return this._getModifiedResults(term, this._filter(A(options), term));
  }

  // If users can create custom values and there isn't an exact match, we return a
  // custom suggested value based on the search term. Otherwise, just return the
  // results.
  _getModifiedResults(term, results) {
    if (!this.args.allowCustomValues || results.some(option => (typeof option === 'object' ? option[this.labelProperty] : option) === term)) {
      return results;
    }
    return [{
      __customvalue__: true,
      value: term,
      label: term
    }, ...results];
  }

  // Filter options based on either a matcher passed in or the default matcher.
  // Options can either be strings or objects. If they are objects, then we look
  // for the `searchField` property.
  _filter(options, searchText) {
    let matcher = this.matcher || this._defaultMatcher;
    return filterOptions(options || [], searchText, (option, text) => matcher(typeof option === 'object' ? get(option, this.searchField) : option, text));
  }
  _defaultMatcher(option, searchTerm) {
    return stringIncludes(option, searchTerm) ? 1 : -1;
  }
}, (_applyDecoratedDescriptor(_class.prototype, "optionsEmArray", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "optionsEmArray"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_computedsearchProperty", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "_computedsearchProperty"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedItems", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "selectedItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_extra", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "_extra"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSelectAction", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSelectAction"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_searchWithCreate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_searchWithCreate"), _class.prototype)), _class));
export { FlyPowerSelectMultiple as default };